export function useRatesTable<T extends object>(
    apiUrl: string,
    mockRates: T[],
    filterCountry: Ref<string | undefined>
) {
    const url = useRuntimeConfig().public.baseURL;

    const { data: fetchRates } = useAsyncData(`rates-${apiUrl}`, async () => {
        if (!url) return null;
        try {
            const fetchUrl = apiUrl === '/rate/default' ? '/api/rates' : `${url}${apiUrl}`;
            const response = await $fetch<T[]>(fetchUrl);
            return response;
        } catch (e) {
            console.warn("API Error:", e);
            return null;
        }
    });

    const getFirstWordOfCountry = (name: string) => {
        if (!name) return '';
        if (name.includes('Ukraine')) return 'Ukraine';
        const words = name.split(' ');
        return words.length > 0 ? words[0] : name;
    };

    const rates = computed(() => {
        let baseList =
            fetchRates.value && Array.isArray(fetchRates.value) && fetchRates.value.length > 0
                ? fetchRates.value
                : mockRates;

        if (filterCountry.value) {
            let list = baseList.filter((r: any) =>
                (r.countryName || r.country || '')
                    .toLowerCase()
                    .includes(getFirstWordOfCountry(filterCountry.value!).toLowerCase())
            );
            if (list.length === 0 && baseList !== mockRates) {
                list = mockRates.filter((r: any) =>
                    (r.countryName || r.country || '')
                        .toLowerCase()
                        .includes(getFirstWordOfCountry(filterCountry.value!).toLowerCase())
                );
            }

            // Fallback for "Other countries"
            if (list.length === 0) {
                list = baseList.filter((r: any) => {
                    const n = (r.countryName || r.country || '').toLowerCase();
                    return n === 'other countries' || n === '';
                });

                if (list.length === 0 && baseList !== mockRates) {
                    list = mockRates.filter((r: any) => {
                        const n = (r.countryName || r.country || '').toLowerCase();
                        return n === 'other countries' || n === '';
                    });
                }

                list = list.map((r: any) => ({
                    ...r,
                    country: filterCountry.value,
                    countryName: filterCountry.value
                }));
            }

            return list;
        }
        return baseList;
    });

    return {
        rates
    };
}
